import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { Drawing } from '../../interfaces/state/entities/drawing.interface';
import { IDrawingsService } from '../../interfaces/services/drawings-service.interface';
import { FloorsMockService } from '../floors/floors-mock.service';
import {
  mockBytesFromMb,
  mockBytesString,
  mockDaysAgo,
  mockHoursAgo,
  mockMinutesAgo,
  mockNormalizeFileSize,
} from '../mock/mock-data.utils';

@Injectable({ providedIn: 'root' })
export class DrawingsMockService implements IDrawingsService {
  private readonly floorsService = inject(FloorsMockService);
  private drawings: Drawing[] = [];
  private idCounter = 0;

  constructor() {
    const now = new Date();
    const mockDrawings: Drawing[] = [
      {
        id: '1',
        floorId: '1',
        drawingName: 'Revision 1',
        status: 'Processed',
        processId: '744624f1-6b3f-4055-9402-4cd4a5b23ca8',
        dateCreated: mockDaysAgo(now, 25),
        dateProcessed: mockDaysAgo(now, 24),
        lastModified: mockDaysAgo(now, 24),
        revisionNumber: 1,
        fileSize: mockBytesFromMb(2.5),
      },
      {
        id: '2',
        floorId: '1',
        drawingName: 'Revision 2',
        status: 'Processed',
        processId: 'fae9f763-6c9f-4116-af6d-d71d0948afb6',
        dateCreated: mockDaysAgo(now, 10),
        dateProcessed: mockDaysAgo(now, 9),
        lastModified: mockDaysAgo(now, 9),
        revisionNumber: 2,
        fileSize: mockBytesFromMb(3.1),
      },
      {
        id: '8',
        floorId: '1',
        drawingName: 'Revision 3',
        status: 'Active',
        dateCreated: mockDaysAgo(now, 3),
        dateProcessed: undefined,
        lastModified: mockDaysAgo(now, 3),
        revisionNumber: 3,
        fileSize: mockBytesFromMb(2.8),
      },
      {
        id: '9',
        floorId: '1',
        drawingName: 'Revision 4',
        status: 'Failed',
        dateCreated: mockDaysAgo(now, 2),
        dateProcessed: undefined,
        lastModified: mockDaysAgo(now, 2),
        revisionNumber: 4,
        fileSize: mockBytesFromMb(3.4),
      },
      {
        id: '10',
        floorId: '1',
        drawingName: 'Revision 5',
        status: 'Pending',
        dateCreated: mockHoursAgo(now, 2),
        dateProcessed: undefined,
        lastModified: mockHoursAgo(now, 2),
        revisionNumber: 5,
        fileSize: mockBytesFromMb(2.2),
      },
      {
        id: '11',
        floorId: '1',
        drawingName: 'Revision 6',
        status: 'Uploaded',
        dateCreated: mockHoursAgo(now, 5),
        dateProcessed: undefined,
        lastModified: mockHoursAgo(now, 5),
        revisionNumber: 6,
        fileSize: mockBytesFromMb(3.0),
      },
      {
        id: '12',
        floorId: '1',
        drawingName: 'Revision 7',
        status: 'UploadFailed',
        dateCreated: mockMinutesAgo(now, 45),
        dateProcessed: undefined,
        lastModified: mockMinutesAgo(now, 45),
        revisionNumber: 7,
        fileSize: mockBytesFromMb(2.6),
      },
      {
        id: '3',
        floorId: '2',
        drawingName: 'Revision 1',
        status: 'Active',
        dateCreated: mockDaysAgo(now, 5),
        dateProcessed: undefined,
        lastModified: mockDaysAgo(now, 5),
        revisionNumber: 1,
        fileSize: mockBytesFromMb(1.8),
      },
      {
        id: '13',
        floorId: '2',
        drawingName: 'Revision 2',
        status: 'Uploaded',
        dateCreated: mockMinutesAgo(now, 30),
        dateProcessed: undefined,
        lastModified: mockMinutesAgo(now, 30),
        revisionNumber: 2,
        fileSize: mockBytesFromMb(2.4),
      },
      {
        id: '4',
        floorId: '5',
        drawingName: 'Revision 1',
        status: 'Failed',
        dateCreated: mockDaysAgo(now, 20),
        dateProcessed: undefined,
        lastModified: mockDaysAgo(now, 20),
        revisionNumber: 1,
        fileSize: mockBytesFromMb(4.2),
      },
      {
        id: '5',
        floorId: '6',
        drawingName: 'Revision 1',
        status: 'Processed',
        dateCreated: mockDaysAgo(now, 18),
        dateProcessed: mockDaysAgo(now, 17),
        lastModified: mockDaysAgo(now, 17),
        revisionNumber: 1,
        fileSize: mockBytesFromMb(2.9),
      },
      {
        id: '6',
        floorId: '6',
        drawingName: 'Revision 2',
        status: 'Processed',
        dateCreated: mockDaysAgo(now, 12),
        dateProcessed: mockDaysAgo(now, 11),
        lastModified: mockDaysAgo(now, 11),
        revisionNumber: 2,
        fileSize: mockBytesFromMb(3.5),
      },
      {
        id: '7',
        floorId: '6',
        drawingName: 'Revision 3',
        status: 'Active',
        dateCreated: mockDaysAgo(now, 3),
        dateProcessed: undefined,
        lastModified: mockDaysAgo(now, 3),
        revisionNumber: 3,
        fileSize: mockBytesFromMb(4.0),
      },
      {
        id: '14',
        floorId: '8',
        drawingName: 'Revision 1',
        status: 'Processed',
        dateCreated: mockDaysAgo(now, 15),
        dateProcessed: mockDaysAgo(now, 14),
        lastModified: mockDaysAgo(now, 14),
        revisionNumber: 1,
        fileSize: mockBytesFromMb(2.1),
      },
      {
        id: '15',
        floorId: '8',
        drawingName: 'Revision 2',
        status: 'Processed',
        dateCreated: mockDaysAgo(now, 12),
        dateProcessed: mockDaysAgo(now, 11),
        lastModified: mockDaysAgo(now, 11),
        revisionNumber: 2,
        fileSize: mockBytesFromMb(2.8),
      },
      {
        id: '16',
        floorId: '8',
        drawingName: 'Revision 3',
        status: 'Processed',
        dateCreated: mockDaysAgo(now, 9),
        dateProcessed: mockDaysAgo(now, 8),
        lastModified: mockDaysAgo(now, 8),
        revisionNumber: 3,
        fileSize: mockBytesFromMb(3.2),
      },
      {
        id: '17',
        floorId: '9',
        drawingName: 'Revision 1',
        status: 'Processed',
        dateCreated: mockDaysAgo(now, 4),
        dateProcessed: mockDaysAgo(now, 3),
        lastModified: mockDaysAgo(now, 3),
        revisionNumber: 1,
        fileSize: mockBytesFromMb(2.5),
      },
    ];

    this.drawings = mockDrawings.map((drawing) => ({
      ...drawing,
      fileSize: mockNormalizeFileSize(drawing.fileSize),
    }));
    this.idCounter = mockDrawings.length;
  }

  getDrawings(floorId: string): Observable<Drawing[]> {
    return of(this.drawings.filter((d) => d.floorId === floorId)).pipe(delay(100));
  }

  addDrawing(floorId: string, name: string, fileSize: number, _file: File): Observable<Drawing> {
    const now = new Date();
    const revisionNumber = this.drawings.filter((d) => d.floorId === floorId).length + 1;
    const drawing: Drawing = {
      id: String(++this.idCounter),
      floorId,
      drawingName: name,
      status: 'Pending',
      dateCreated: now,
      dateProcessed: undefined,
      lastModified: now,
      revisionNumber,
      fileSize: mockBytesString(fileSize),
    };
    this.drawings.push(drawing);
    this.floorsService.syncCurrentRevision(floorId, revisionNumber);
    return of(drawing).pipe(delay(100));
  }

  retryProcessingDrawing(drawingId: string, fileSize: number): Observable<void> {
    const drawing = this.drawings.find((d) => d.id === drawingId);
    if (drawing) {
      const now = new Date();
      drawing.status = 'Processed';
      drawing.fileSize = mockBytesString(fileSize);
      drawing.dateProcessed = now;
      drawing.lastModified = now;
    }
    return of(undefined).pipe(delay(100));
  }
}
